// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

export interface TrainCoachSaveParams {
  /** 雪花 ID，需以字符串传递避免精度丢失 */
  id?: string;
  /** 雪花 ID，需以字符串传递避免精度丢失 */
  gymId?: number | string;
  realName: string;
  nickname?: string;
  avatarUrl?: string;
  realPhoto?: string;
  phone?: string;
  idCard?: string;
  gender?: number;
  birthDate?: string;
  hireDate?: string;
  address?: string;
  workYears?: number;
  expertise?: string;
  expertiseTags?: string;
  professionalCertificates?: string;
  bio?: string;
  coachStatus?: number;
}

export interface TrainCoachListItem extends TrainCoachSaveParams {
  id: string;
  honorAchievements?: string;
  createTime?: string;
  updateTime?: string;
}

export interface TrainCoachPageResult {
  dataInfo?: TrainCoachListItem[];
  pageInfo?: API.YmPageInfo;
}

export interface TrainCoachHonorParams {
  /** 雪花 ID，需以字符串传递避免精度丢失 */
  id?: string;
  coachId: string;
  eventName: string;
  awardName?: string;
  eventDate?: string;
  eventDescription?: string;
  certificateUrls?: string;
  createTime?: string;
  updateTime?: string;
}

export async function addCoach(body: TrainCoachSaveParams) {
  return request<API.ResponseVO<string>>('/web/v1/train/coach/add', {
    method: 'POST',
    data: body,
  });
}

export async function deleteCoach(params: { id: string }) {
  return request<API.ResponseVO<void>>(
    `/web/v1/train/coach/delete/${params.id}`,
    {
      method: 'GET',
    },
  );
}

export async function updateCoach(body: TrainCoachSaveParams) {
  return request<API.ResponseVO<void>>('/web/v1/train/coach/update', {
    method: 'POST',
    data: body,
  });
}

export async function getCoachDetail(params: { id: string }) {
  return request<API.ResponseVO<TrainCoachListItem>>(
    `/web/v1/train/coach/detail/${params.id}`,
    { method: 'GET' },
  );
}

export async function getCoachList(body: {
  gymId?: number | string;
  name?: string;
}) {
  return request<API.ResponseVO<TrainCoachListItem[]>>(
    '/web/v1/train/coach/list',
    {
      method: 'POST',
      data: body,
    },
  );
}

/** 可用教练简项（GET /web/v1/train/coach/available/coach） */
export interface AvailableCoachItem {
  id?: number | string;
  name?: string;
  /** 教练状态：1在职 2休假 3离职 */
  status?: number;
  /** 教练状态名称 */
  statusName?: string;
  /** 是否默认可排课（仅在职为 true） */
  schedulable?: boolean;
}

/**
 * 12109-查询可用教练 GET /web/v1/train/coach/available/coach
 * @param statuses 状态过滤：1在职 2休假 3离职，可多选；不传默认仅在职
 */
export async function getAvailableCoaches(params?: {
  statuses?: number[];
}) {
  return request<API.ResponseVO<AvailableCoachItem[]>>(
    '/web/v1/train/coach/available/coach',
    {
      method: 'GET',
      params: params?.statuses?.length
        ? { statuses: params.statuses }
        : undefined,
      // axios 默认把数组编成 statuses[]=1，Spring 只绑定重复键 statuses=1&statuses=2
      paramsSerializer: { indexes: null },
    },
  );
}

export async function getCoachPageList(body: {
  gymId?: number | string;
  page?: number;
  pageSize?: number;
  keyword?: string;
  coachStatus?: number;
}) {
  return request<API.ResponseVO<TrainCoachPageResult>>(
    '/web/v1/train/coach/pageList',
    { method: 'POST', data: body },
  );
}

export async function updateCoachStatus(body: {
  coachId: string;
  status: number;
}) {
  return request<API.ResponseVO<void>>('/web/v1/train/coach/status/update', {
    method: 'POST',
    data: body,
  });
}

export async function addCoachHonor(body: TrainCoachHonorParams) {
  return request<API.ResponseVO<string>>('/web/v1/train/coach/honor/add', {
    method: 'POST',
    data: body,
  });
}

export async function getCoachHonorList(params: { coachId: string }) {
  return request<API.ResponseVO<TrainCoachHonorParams[]>>(
    `/web/v1/train/coach/honor/list/${params.coachId}`,
    { method: 'GET' },
  );
}

export async function updateCoachHonor(body: TrainCoachHonorParams) {
  return request<API.ResponseVO<void>>('/web/v1/train/coach/honor/update', {
    method: 'POST',
    data: body,
  });
}

export async function deleteCoachHonor(params: { id: string }) {
  return request<API.ResponseVO<void>>(
    `/web/v1/train/coach/honor/delete/${params.id}`,
    { method: 'GET' },
  );
}
